// Modules
import { produce } from 'immer'

// Constants
import { tabsList } from 'pages/Dashboard/components/LeftNavbar/Tabs/MarketWatch/TopTabs/constants'

// Types
import {
  ADD_EXPANDABLE_ACCORDION_INDS,
  ADD_INNER_LIST_EXPANDABLE_ACCORDION_INDS,
  DELETE_EXPANDABLE_ACCORDION_INDS,
  DELETE_INNER_LIST_EXPANDABLE_ACCORDION_INDS,
  SET_ACCORDION_SEARCH_VALUE,
  SET_ACTIVE_MARKET_TOP_TAB,
  SET_EXPANDABLE_ACCORDION_INDS,
  SET_INNER_LIST_EXPANDABLE_ACCORDION_INDS,
  SET_IS_CHOOSE_FIRST_TIME_INNER_ACCORDION_ID,
  WS_SET_SOCKET_CURRENCY_PARAMETERS,
} from 'store/actions/marketSidebar/types'

const initialState = {
  expandableAccordionInds: [],
  innerListExpandableAccordionInds: [],

  // all //favourite tabs
  marketTopTabValue: tabsList[0].id,
  // for socket parameters groups['crypto'], channels['BTC]
  socketMarketParameters: { groups: [], channels: [] },
  accordionSearchValue: '',
  isChooseFirstTimeInnerAccordionId: false,
}

const marketSidebarReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_EXPANDABLE_ACCORDION_INDS:
        draft.expandableAccordionInds = action.payload
        break
      case ADD_EXPANDABLE_ACCORDION_INDS:
        draft.expandableAccordionInds.push(action.payload)
        break
      case DELETE_EXPANDABLE_ACCORDION_INDS:
        draft.expandableAccordionInds = draft.expandableAccordionInds.filter(
          (item) => item !== action.payload,
        )
        break
      case SET_INNER_LIST_EXPANDABLE_ACCORDION_INDS:
        draft.innerListExpandableAccordionInds = action.payload
        break
      case ADD_INNER_LIST_EXPANDABLE_ACCORDION_INDS:
        draft.innerListExpandableAccordionInds.push(action.payload)
        break
      case DELETE_INNER_LIST_EXPANDABLE_ACCORDION_INDS:
        draft.innerListExpandableAccordionInds = draft.innerListExpandableAccordionInds.filter(
          (item) => item !== action.payload,
        )
        break
      case SET_ACTIVE_MARKET_TOP_TAB:
        draft.marketTopTabValue = action.payload
        break
      case WS_SET_SOCKET_CURRENCY_PARAMETERS:
        draft.socketMarketParameters = action.payload
        break
      case SET_ACCORDION_SEARCH_VALUE:
        draft.accordionSearchValue = action.payload
        break
      case SET_IS_CHOOSE_FIRST_TIME_INNER_ACCORDION_ID:
        draft.isChooseFirstTimeInnerAccordionId = action.payload
        break
      default:
        break
    }
  })

export default marketSidebarReducer
